import {
  ProductFilterColumns,
  ProductFilterModel,
  useProductFilter,
  useSetProductFilter,
  useValidateProductListOrder,
} from '@gripp/shared-logic';
import {
  ColumnsFilterScreen,
  ColumnsFilterScreenHandle,
  SlideAction,
  SlideLayout,
  useSlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { useRef } from 'react';
import { useNavigate } from 'react-router';
import { HeaderResetButton } from '../../shared/components/headerResetButton/headerResetButton';
import { ProductsComponent } from './productsComponent';
import { ProductsFilters } from './productsFilters';

export const ProductsFilterPage = () => {
  const filterRef = useRef<ColumnsFilterScreenHandle>(null);
  const onBackButtonPressRef = useRef<(() => void) | undefined>(undefined);

  const { data: filter } = useProductFilter();
  const { mutateAsync: setFilter } = useSetProductFilter();
  const validateListOrder = useValidateProductListOrder();

  const leftColumn = {
    title: 'product.list.products',
    mainComponent: <ProductsComponent />,
    headerComponent: <ProductsFilters />,
    disableScroll: true,
  };

  const rightColumn = {
    title: 'product.list.products',
    mainComponent: (
      <>
        <ColumnsFilterScreen
          ref={filterRef}
          mode="page"
          filter={filter}
          setFilter={setFilter}
          validateListOrder={validateListOrder}
          createDefaultFilter={() => new ProductFilterModel()}
          createFilter={(data) => new ProductFilterModel(data)}
          baseColumns={ProductFilterColumns}
          i18nPrefix="product.filter"
          viewResultsTranslationKey="common.apply"
          bottomBar={() => <></>}
        />
        <BackHandlerRegistrar onBackButtonPressRef={onBackButtonPressRef} />
      </>
    ),
    headerComponent: (
      <HeaderResetButton onReset={() => filterRef.current?.onReset()} />
    ),
    showBackButton: true,
    onBackButtonPress: () => onBackButtonPressRef.current?.(),
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};

const BackHandlerRegistrar = ({
  onBackButtonPressRef,
}: {
  onBackButtonPressRef: React.MutableRefObject<(() => void) | undefined>;
}) => {
  const navigate = useNavigate();
  const { onSlideChange } = useSlideLayout();

  onBackButtonPressRef.current = async () => {
    await onSlideChange(SlideAction.SINGLE);
    navigate('/products');
  };

  return null;
};
